import React from 'react';
import { Box, Typography } from '@mui/material';

export interface StatusLabelProps {
  status: string;
}

const getStatusDetails = (status: string) => {
  switch (status) {
    case 'New':
      return {
        label: 'New',
        bgColor: '#6366f1',
        textColor: '#4338ca',
      };
    case 'rejected':
      return {
        label: 'Rejected',
        bgColor: '#f43f5e',
        textColor: '#be123c',
      };
    case 'candidate rejected':
      return {
        label: 'Candidate Rejected',
        bgColor: '#f59e0b',
        textColor: '#b45309',
      };
    case 'failed':
      return {
        label: 'Failed',
        bgColor: '#dc2626',
        textColor: '#991b1b',
      };
    case 'Invited':
      return {
        label: 'Invited',
        bgColor: '#38bdf8',
        textColor: '#0284c7',
      };
    case 'Confirmed':
      return {
        label: 'Confirmed',
        bgColor: '#10b981',
        textColor: '#047857',
      };
    case 'Completed':
      return {
        label: 'Completed',
        bgColor: '#3b82f6',
        textColor: '#1d4ed8',
      };
    case 'Scheduled':
      return {
        label: 'Scheduled',
        bgColor: '#8b5cf6',
        textColor: '#6d28d9',
      };
    default:
      return {
        label: 'Unknown',
        bgColor: '#cbd5e1',
        textColor: '#475569',
      };
  }
};

export const StatusLabel: React.FC<StatusLabelProps> = ({ status = 'unknown' }) => {
  if (!status) {
    return <Typography variant='body2'>Invalid status</Typography>;
  }

  const { label, bgColor, textColor } = getStatusDetails(status);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        component='span'
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: bgColor,
          boxShadow: `0 0 0 2px #fff, 0 0 0 4px ${bgColor}40`,
        }}
      />
      <Typography
        variant='body2'
        sx={{ color: textColor, fontWeight: 500, fontSize: '0.875rem' }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default StatusLabel;
